import { CIcon } from '@coreui/icons-react';
import {
  CAlert,
  CButton, CCol, CContainer, CFormGroup, CLabel, CModal, CModalBody, CModalFooter, CModalHeader,
  CModalTitle, CRow, CSelect, CInput, CSpinner
} from '@coreui/react';
import React, { useEffect, useRef, useState } from 'react';
import { accountTypes } from '../../constants/Options';
import Backend from '../../utils/Backend';
import General from '../../utils/General';
import Notify from '../../utils/Notify';
import { months } from '../../constants/Options';
import moment from 'moment';
import AuthManager from '../../utils/AuthManager';


export default function BulkContributionModal(props) {
  var tabIndex = 0
  const branchRef = useRef(null)
  const accountTypeRef = useRef(null)
  const fyRef = useRef(null)
  const monthRef = useRef(null)
  const yearRef = useRef(null)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [branches, setBranches] = useState([])
  const [financialYears, setFinancialYears] = useState([])
  const [years, setYears] = useState([])
  const [contributions, setContributions] = useState([])
  // const [contributionPercentage, setContributionPercentage] = useState(0)
  const [item, setContribution] = useState(
    {
      fiscal_account_id: '',
      month: '',
      year: '',
      amount: 0.00,
      interest_rate: 0.00,
    })



  function handleFormChange(evt) {
    setError('')
    let name = evt.target.name;
    let value = evt.target.value;
    if (name === 'amount' || name === 'interest_rate') {
      value = parseFloat(parseFloat(value).toFixed(2))
    }

    setContribution({ ...item, [name]: value })
  }

  function validateFilterData() {
    setError('')
    if (!branchRef.current.value) {
      setError('Select Department')
      branchRef.current.focus()
      return false;
    } else if (!accountTypeRef.current.value) {
      setError('Select Account Type')
      accountTypeRef.current.focus()
      return false;
    } else if (!fyRef.current.value) {
      setError('Select Financial Year')
      fyRef.current.focus()
      return false;
    } else if (!monthRef.current.value) {
      setError('Select Contribution Month')
      monthRef.current.focus()
      return false;
    } else if (!yearRef.current.value) {
      setError('Select Contribution Year')
      yearRef.current.focus()
      return false;
    }

    setError('')
    getFilteredContributions()
  }

  const setAmount = async (item, value) => {
    let items = contributions.map(contribution => {
      if (item.id === contribution.id) {
        return {
          ...item,
          amount: value,
        }
      }
      return contribution
    })

    setContributions([...items])
  }

  const setInterest = async (item, value) => {
    let items = contributions.map(contribution => {
      if (item.id === contribution.id) {
        return {
          ...item,
          interest_rate: value,
        }
      }
      return contribution
    })

    setContributions([...items])
  }

  async function payContributions() {
    setLoading(true)
    try {

      let updatedContributions = await Promise.all(
        contributions.map(async (item) => {
          if (parseFloat(item.amount) > 0 && !item.contribution) {
            const response = await Backend.addContribution(item)
            if (response.data) {
              item.contribution = response.data
            }
          }
        })
      )
      //setContributions([...updatedContributions])
      setLoading(false)
    } catch (error) {
      //setError(error.message)
      setLoading(false)
      Notify.error(error.message)
    }
  }

  async function payContribution(item) {
    setLoading(true)

    try {
      if (parseFloat(item.amount) > 0 && !item.contribution) {
        const response = await Backend.addContribution(item)
        if (response.data) {
          item.contribution = response.data
        }
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      Notify.error(error.message)
    }
  }


  const getFilteredContributions = async () => {
    try {
      let params = `?branch_id=${branchRef.current.value}&account_type=${accountTypeRef.current.value}` +
        `&financial_year_id=${fyRef.current.value}&month=${monthRef.current.value}&year=${yearRef.current.value}`

      const response = await Backend.getFilteredContributions(params);
      if (response.data) {
        setContributions([...response.data])
      }
    } catch (error) {
      setContributions([])
      Notify.error(error.message)
      console.log(error)
    }
  }

  const initInterestRate = async () => {
    try {
      const response = await Backend.getSetting('epf_interest_rate');
      if (response.data) {
        setContribution({ ...item, interest_rate: parseFloat(response.data.value).toFixed(2) })
      }
    } catch (error) {
      console.log(error)
    }
  }

  const initFinancialYears = async () => {
    try {
      const response = await Backend.getFYs();
      if (response.data) {
        setFinancialYears([...response.data])
      }
      setLoading(false)
    } catch (error) {
      console.log(error)
      Notify.error(error.message)
      setLoading(false)
    }
  }

  const getCurrentFY = async () => {
    try {
      const response = await Backend.getCurrentFY();
      if (response.data) {
        fyRef.current.value = response.data.id
        setSelectedFYYears(response.data.id)
      }
      setLoading(false)
    } catch (error) {
      console.log(error)
      Notify.error(error.message)
      setLoading(false)
    }
  }


  const setSelectedFYYears = (fyId) => {
    yearRef.current.value = ''
    let fy = financialYears.find(item => item.id == fyId)
    if (fy) {
      fyRef.current.value = fyId
      setYears(General.getFYYears([fy]))
    } else {
      setYears([])
    }
  }

  const initBranches = async () => {
    try {
      const response = await Backend.getBranches();
      if (response.data) {
        setBranches([...response.data])
      }
      setLoading(false)
    } catch (error) {
      console.log(error)
      Notify.error(error.message)
      setLoading(false)
    }
  }

  useEffect(() => {
    initInterestRate()
    initBranches()
    initFinancialYears()

    return () => {
    }
  }, [])

  useEffect(() => {
    if (financialYears.length) {
      getCurrentFY()
    }
  }, [financialYears])

  return (
    <>
      <CModal
        show={props.show}
        centered={true}
        className={'w-100'}
        size={'xl'}
        onClose={() => props.onClose()}
      >
        <CModalHeader closeButton>
          <CModalTitle>Add Contributions </CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CContainer fluid>
            <CRow>
              {
                error && <CAlert color={'danger'} className={'w-100'}>{error}</CAlert>
              }
            </CRow>
            <CRow>
              <CCol className>
                <CFormGroup>
                  <CLabel>Department</CLabel>
                  <CSelect
                    innerRef={branchRef}
                    onChange={() => {
                      setContributions([])
                    }}
                  >
                    <option value="">----</option>
                    {
                      branches.map(branch => {
                        return (<option value={branch.id}>{branch.name}</option>)
                      })
                    }
                  </CSelect>
                </CFormGroup>
              </CCol>
              <CCol>
                <CFormGroup>
                  <CLabel>Account Type</CLabel>
                  <CSelect
                    innerRef={accountTypeRef}
                    onChange={() => {
                      setContributions([])
                    }}
                  >
                    <option value="">----</option>
                    {
                      AuthManager.getCurrentUser().role !== 'admin' ?
                        [
                          accountTypes.map(accountType => {
                            if (accountType.value === AuthManager.getCurrentUser().role)
                              return (<option value={accountType.value}>{accountType.label}</option>)
                          })
                        ]
                        :
                        accountTypes.map(accountType => {
                          return (<option value={accountType.value}>{accountType.label}</option>)
                        })
                    }
                  </CSelect>
                </CFormGroup>
              </CCol>
              <CCol className={'col-sm-3'}>
                <CFormGroup>
                  <CLabel>Financial Year</CLabel>
                  <CSelect
                    innerRef={fyRef}
                    onChange={(e) => {
                      if (e.target.value) {
                        setSelectedFYYears(e.target.value)
                      } else {
                        setYears([])
                      }

                      setContributions([])
                    }}
                  >
                    <option value="">----</option>
                    {
                      financialYears.map(fy => {
                        return (<option value={fy.id}>{General.getFyName(fy)}</option>)
                      })
                    }
                  </CSelect>
                </CFormGroup>
              </CCol>
              <CCol>
                <CFormGroup>
                  <CLabel> Month</CLabel>
                  <CSelect
                    innerRef={monthRef}
                    onChange={() => {
                      setContributions([])
                    }}
                  >
                    <option value="">----</option>
                    {
                      months.map(month => {
                        return (<option value={month.value}>{month.label}</option>)
                      })
                    }
                  </CSelect>
                </CFormGroup>
              </CCol>
              <CCol>
                <CFormGroup>
                  <CLabel> Year</CLabel>
                  <CSelect
                    innerRef={yearRef}
                    onChange={() => {
                      setContributions([])
                    }}
                  >
                    <option value="">----</option>
                    {
                      years.map(year => {
                        return (<option value={year}>{year}</option>)
                      })
                    }
                  </CSelect>
                </CFormGroup>
              </CCol>
              <CCol className={'col-sm-3'}>
                <CFormGroup>
                  <CLabel>&nbsp;</CLabel><br />
                  <CButton color="dark" className="btn-sm" style={{ paddingLeft: '20px', paddingRight: '20px' }}
                    onClick={() => {
                      validateFilterData()
                    }} ><CIcon name="cil-filter" /> Show Employees</CButton>
                </CFormGroup>
              </CCol>
            </CRow>
            <CRow style={{ minHeight: '100px' }}>
              {
                contributions.map((item, index) => {
                  return (
                    <CAlert color={item.contribution !== null ? 'success' : 'dark'} className={'mb-1 w-100'}>
                      <CRow>
                        <CCol className={'col-sm-12'}>
                          {
                            (item.contribution !== null) ?
                              (
                                <dl className="row mb-0">
                                  <dt className="col-sm-3">Employee :</dt>
                                  <dd className="col-sm-3">{item.employee.name}</dd>
                                  <dt className="col-sm-3">Contribution month/year :</dt>
                                  <dd className="col-sm-3">{moment(item.contribution.date).format('MM/YYYY')}</dd>
                                  <dt className="col-sm-3">Payment Date :</dt>
                                  <dd className="col-sm-3">{moment(item.contribution.created_at).format('DD/MM/YYYY')}</dd>
                                  <dt className="col-sm-3">Amount :</dt>
                                  <dd className="col-sm-3">{General.formatRupees(item.contribution.amount)}</dd>
                                  <dt className="col-sm-3">Interest Rate :</dt>
                                  <dd className="col-sm-3">{(item.contribution.interest_rate / 12).toFixed(2)}%</dd>
                                </dl>
                              )
                              :
                              (

                                <CRow>
                                  <CCol className={'col-sm-3'}>
                                    <CFormGroup>
                                      <CLabel><strong>Employee:</strong></CLabel><br />
                                      <CLabel>{item.employee.name}</CLabel>
                                    </CFormGroup>
                                  </CCol>
                                  <CCol className={'col-sm-3'}>
                                    <CFormGroup>
                                      <CLabel><strong>Contribution month/year :</strong></CLabel><br />
                                      <CLabel>{item.month}/{item.year}</CLabel>
                                    </CFormGroup>
                                  </CCol>
                                  <CCol className={'col-sm-2'}>
                                    <CFormGroup>
                                      <CLabel>Amount</CLabel>
                                      <CInput
                                        value={item.amount}
                                        type="number"
                                        tabIndex={++tabIndex}
                                        min={0}
                                        onChange={(e) => {
                                          if (!isNaN(e.target.value)) {
                                            setAmount(item, e.target.value)
                                          }
                                        }}
                                      />
                                    </CFormGroup>
                                  </CCol>
                                  <CCol className={'col-sm-2'}>
                                    <CFormGroup>
                                      <CLabel>Interest rate per annum</CLabel>
                                      <CInput
                                        value={item.interest_rate}
                                        type="number"
                                        tabIndex={++tabIndex}
                                        min={0}
                                        onChange={(e) => {
                                          if (!isNaN(e.target.value)) {
                                            setInterest(item, e.target.value)
                                          }
                                        }}
                                      />
                                    </CFormGroup>
                                  </CCol>
                                  <CCol className={'col-sm-2'}>
                                    <CFormGroup>
                                      <CLabel className={'w-100'}>&nbsp;</CLabel>
                                      <CButton color="dark" className="btn-sm pl-4 pr-4"
                                        disabled={loading || item.amount < 1}
                                        tabIndex={++tabIndex}
                                        onClick={e => {
                                          e.preventDefault()
                                          payContribution(item)
                                        }}>
                                        {
                                          loading ?
                                            (
                                              <>
                                                <CSpinner component="span" size="sm" aria-hidden="true" />  Saving...
                                              </>
                                            ) : 'Pay Contribution'
                                        }
                                      </CButton>
                                    </CFormGroup>
                                  </CCol>
                                </CRow>
                              )
                          }
                        </CCol>
                      </CRow>
                    </CAlert>
                  )
                })
              }

            </CRow>

          </CContainer>
        </CModalBody>
        <CModalFooter>
          <CButton color="dark" className="btn-sm pl-4 pr-4"
            tabIndex={++tabIndex}
            disabled={loading}
            onClick={e => {
              e.preventDefault()
              payContributions()
            }}>
            {
              loading ?
                (
                  <>
                    <CSpinner component="span" size="sm" aria-hidden="true" />  Saving...
                  </>
                ) : 'Pay All Contributions'
            }
          </CButton>
          <CButton variant="outline" color="danger" className="btn-sm pl-4 pr-4 ml-2"
            disabled={loading}
            onClick={() => props.onClose()}>Close</CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}
